import apiClient from '../api';

export const updateUser = (data, id, header) => apiClient.put(`/user/update/${id}`, data, header);
export const deleteUser = (id) => apiClient.delete(`/user/delete/${id}`);
export const getAllUsers = (data) => apiClient.get('/user/all');
export const getUsersByOrgId = (data) => apiClient.get(`/user/by/organization/${data}`);
export const getProductionTeam = (data) => apiClient.get(`/user/get/production/team`);
export const getFollowUpTeamMember = () => apiClient.get(`/user/followup/teamMember`);
export const getUserDetail = (id) => apiClient.get(`/user/${id}`);
export const getEditorList = () => apiClient.get(`/user/get/editor/list`);

export const updateEditor = (id, data, header) => apiClient.put(`/user/update/editor/${id}`, data, header);

export const createNewsletter = (data, header) => apiClient.post('/user/submit/newsletter', data, header);

export const ssoLoginUser = (token) => apiClient.get(`/user/sso-login?token=${token}`);